import { IPartialCSS } from "partnerbuilder-common";
import {
    AlignStyles,
    BackgroundStyles,
    BorderRadiusStyles,
    BorderStyles,
    BoxShadowSyles,
    ColorStyles,
    FontStyles,
    HeightStyles,
    MarginStyles,
    OpacityStyles,
    PaddingStyles,
    TextShadowSyles,
    WidthStyles
} from "./GroupsStyles.static";

export const TextTypeStyles: IPartialCSS<any> = {
    ...ColorStyles,
    ...FontStyles,
    ...MarginStyles,
    ...PaddingStyles,
    ...AlignStyles,
    ...FontStyles,
    ...BorderRadiusStyles,
    ...BorderStyles,
    ...OpacityStyles,
    ...BoxShadowSyles,
    ...TextShadowSyles,
    ...HeightStyles,
    ...WidthStyles,
    ...BackgroundStyles
};
